<template>
  <v-container id="people" >
    <v-layout column >
      <v-flex class="filterFlex" >
        <v-layout justify-space-between :wrap="computedWrap">
          <v-flex lg3 class="marginFilter">
            <v-text-field v-model="nameSearch" prepend-inner-icon="search" label="Name" solo></v-text-field>
          </v-flex>
          <v-flex lg3 class="marginFilter">
            <v-menu top offset-y>
              <template v-slot:activator="{ on }">
                <v-text-field
                  prepend-inner-icon="people"
                  v-on="on"
                  :label="'Gender: '+ currentGender"
                  solo
                ></v-text-field>
              </template>

              <v-list>
                <v-list-tile
                  v-for="(gender, index) in genderSelect"
                  :key="index"
                  @click="genderClicked(gender)"
                >
                  <v-list-tile-title>{{ gender }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
          <v-flex lg3 class="marginFilter">
            <v-menu top offset-y>
              <template v-slot:activator="{ on }">
                <v-text-field
                  prepend-inner-icon="location_on"
                  v-on="on"
                  :label="'District: '+ currentDistrict"
                  solo
                ></v-text-field>
              </template>

              <v-list>
                <v-list-tile
                  v-for="(district, index) in districtSelect"
                  :key="index"
                  @click="districtClicked(district)"
                >
                  <v-list-tile-title>{{ district }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>

          <v-flex lg3 class="marginFilter">
            <v-menu top offset-y>
              <template v-slot:activator="{ on }">
                <v-text-field
                  prepend-inner-icon="waves"
                  v-on="on"
                  :label="'Agency: ' + currentAgency"
                  solo
                ></v-text-field>
              </template>

              <v-list>
                <v-list-tile
                  v-for="(agency, index) in agencySelect"
                  :key="index"
                  @click="agencyClicked(agency)"
                >
                  <v-list-tile-title>{{ agency }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout  row wrap>
      <v-flex  lg2 md4 sm4 xs6 v-for="person in orderedPeople" :key="person.id">
        <person-card
          :personId="person.id"
          :personName="person.name"
          :personDistrict="person.district"
          :personGender="person.gender"
          :personDate="person.date"
          :personIncidentLocation="person.incident_location"
          :personAge="person.age"
          :personAddress="person.address"
          :personAgency="person.agency"
          :personClassification="person.classification"
          :personIncidentReport="person.incident_report"
          :personStatus="person.status"
          :personNewsSource="person.news_source"
          :personNewsSourceLink="person.news_source_link"
          :personNewsSource2="person.news_source_2"
          :personNewsSource2Link="person.news_source_2_link"
          :personPhoto="person.photo"
          :personImageUrl="person.photo_url"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import PersonCard from "../../components/PersonCard/PersonCard";
import { mapState } from "vuex";
const _ = require("lodash");

export default {
  data() {
    return {
      genderSelect: ["All", "Male", "Female"],
      districtSelect: [
        "All",
        "Anantnag",
        "Bandipora",
        "Baramulla",
        "Budgam",
        "Ganderbal",
        "Jammu",
        "Kistwar",
        "Kulgam",
        "Kupwara",
        "Pulwama",
        "Shopian",
        "Srinagar"
      ],
      agencySelect: ["All", "Armed Forces", "Militants", "Unidentified"],
      nameSearch: "",
      currentAgency: "All",
      currentDistrict: "All",
      currentGender: "All"
    };
  },
  components: {
    PersonCard
  },
  computed: {
    ...mapState({
      storePeople(state) {
        return state.storePeople;
      }
    }),
    orderedPeople: function() {
      return _.orderBy(this.filteredPeople, "district");
    },
    filteredPeople() {
      const vm = this;
      return this.storePeople.filter(person => {
        let ourPersonsGender = [person.gender, "All"];
        let ourPersonsDistrict = [person.district, "All"];
        let ourPersonsAgency = [person.agency, "All"];
        return (
          person.name.toLowerCase().match(this.nameSearch.toLowerCase()) &&
          ourPersonsGender.includes(vm.currentGender) &&
          ourPersonsDistrict.includes(vm.currentDistrict) &&
          ourPersonsAgency.includes(vm.currentAgency)
        );
      });
    },
    computedWrap() {
      if (window.innerWidth <= 700) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    genderClicked(gender) {
      this.currentGender = gender;
    },
    agencyClicked(agency) {
      this.currentAgency = agency;
    },
    districtClicked(district) {
      this.currentDistrict = district;
    }
  }
};
</script>

<style lang="stylus" scoped>
.filterFlex {
  margin: 2rem 2rem 0 2rem;
}

.peopleTextFlex {
  margin: 2rem;
}

.marginFilter {
  margin: 0 0.8rem 0 0;
}
</style>
